import { render, staticRenderFns } from "./NotSuitable.vue?vue&type=template&id=25bd74f0"
import script from "./NotSuitable.vue?vue&type=script&lang=js"
export * from "./NotSuitable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25bd74f0')) {
      api.createRecord('25bd74f0', component.options)
    } else {
      api.reload('25bd74f0', component.options)
    }
    module.hot.accept("./NotSuitable.vue?vue&type=template&id=25bd74f0", function () {
      api.rerender('25bd74f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/NotSuitable.vue"
export default component.exports